export default function WorkItems({item}){
    const {image, title, link} = item;
    return(
        <div className="work__card">
            <img src={image} alt={title} className="work__img" />
            <h3 className="work__title">{title}</h3>
            <a href={link} target="_blank" rel="noreferrer" className="work__button">Demo <i className="bx bx-right-arrow-alt work__button-icon"></i></a>
        </div>
    )
}